import React, { useEffect, useRef, useState } from 'react';
import { PTag } from '../StyledTags/styledTags';
import style from './cqc.module.css';

const CQCSection = () => {
  const sectionRef = useRef(null);
  const widgetRef = useRef(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const currentSection = sectionRef.current;

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          setAnimate(true);
        } else {
          setAnimate(false); // reset when out of view so it replays
        }
      },
      { threshold: 0.2 }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  // Inject CQC widget script
  useEffect(() => {
      const currentWidget = widgetRef.current;
      if (!currentWidget) return;

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://www.cqc.org.uk/sites/all/modules/custom/cqc_widget/widget.js?data-id=1-10528758258&data-host=https://www.cqc.org.uk&type=location';
      script.async = true;

      currentWidget.appendChild(script);

      return () => {
        currentWidget.innerHTML = '';
      };
    }, []);

  return (
    <section
      className={`${style.cqcMain} ${animate ? style.animate : ''}`}
      ref={sectionRef}
    >
      <div className={style.cqcLeft}>
        <h3>We are registered and regulated by the Care Quality Commission (CQC).</h3>
        <PTag>
          Our CQC registration reflects our commitment to providing the highest standards of care and support.
          We ensure our services meet and exceed regulatory requirements.
        </PTag>
      </div>

      <div className={style.cqcRight} ref={widgetRef} />
    </section>
  );
};

export default CQCSection;
